// extracted by mini-css-extract-plugin
module.exports = {"box_title":"box_title-39V-RzDW","title":"title-HgBp18Df"};